import request from '@/utils/request'



// 查询交易单列表
export function listPayment(query) {
  return request({
    url: '/biz/admin/order/payment/list',
    method: 'get',
    params: query
  })
}

// 查询交易单分页
export function pagePayment(query) {
  return request({
    url: '/biz/admin/order/payment/page',
    method: 'get',
    params: query
  })
}


export function paymentStatus(data) {
  return request({
    url: '/biz/admin/order/payment/pay/status',
    method: 'post',
    data: data
  })
}



export function refundStatus(data) {
  return request({
    url: '/biz/admin/order/payment/refund/status',
    method: 'post',
    data: data
  })
}

export function refundDirect(data) {
  return request({
    url: '/biz/admin/order/payment/refund/direct',
    method: 'post',
    data: data
  })
}